import  { combineReducers } from 'redux' ; 
import CoursesReducer from './courses'
import UserReducer from './user'
import ContentReducer from './content';
import CourseStructureReducer from './courseStructure';
import ContentPositionReducer from './contentPosition';
import KeyboardReducer from './keyboard';
import ProgressReducer from './progress';
import SupportReducer from './support' ;
import AppReducer from './app'
import CommentReducer from './comment';


export default combineReducers ({ ContentPositionReducer, CoursesReducer, UserReducer, ContentReducer, CommentReducer,
                                  KeyboardReducer, ProgressReducer, CourseStructureReducer, SupportReducer, AppReducer,  }) ; 